import angular from 'angular'
import loanCalculatorComponent from './loanCalculator.component'
import calculatorServiceModule from '../../services/calculator/calculator'

export default angular.module('app.common.loanCalculator', [calculatorServiceModule.name])
  .directive('loanCalculator', loanCalculatorComponent)
